import * as React from 'react';
import { Dropdown } from 'semantic-grab-ui/src';
import _ from 'lodash';
import { allowedOperators } from 'data/trident-campaigns';
import './WidgetComponent.scss';
import { Campaign } from 'types/ts/campaigns';

interface Props {
  model: Campaign,
  currentNode: string,
  parentNode: string,
};

interface State {
  currentNode: string,
}

export default class DelayShow extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      currentNode: this.props.currentNode,
    };
  }
  render() {
    const { model } = this.props;
    const { currentNode } = this.state;
    const conditions = _.get(model.nodes[currentNode], 'data.condition.conditions', []);
    if (_.isEmpty(conditions)) {
      const data = _.get(model.nodes[currentNode], 'data.condition', {});
      if (!_.isEmpty(data)) {
        conditions.push(data);
      }
    }
    return (
      <div>
        <span>
          {_.isEmpty(conditions) &&
            <span className="wrapSpan">Delay duration of {_.get(model.nodes[currentNode], 'data.durationInMin')} mins applied.</span>
          }
          {conditions.map((condition) => {
            return (
              <div key={condition.lhs} className="wrapDelayCondition">
                <span>
                  <span className="wrapSpan">
                    {condition.lhs}
                  </span>
                  <span> {' '} </span>
                  <span>
                    <Dropdown
                      name="operator"
                      inline
                      options={allowedOperators}
                      value={condition.operator}
                      disabled
                    />
                  </span>
                  <span> {' '} </span>
                  <span className="wrapSpan">
                    {_.get(model.nodes[currentNode], 'data.durationInMin')}
                  </span>
                </span>
              </div>
            );
          })}
        </span>
      </div>
    );
  }
}
